import $ from 'jquery';

import AppleLoader from 'chairisher/thirdparty/apple';
import GoogleAnalyticsUtils from 'chairisher/util/googleanalytics';

import { getAppleClientId, getAppleRedirectUri } from 'chairisher/context/apple';
import { handleAsyncError } from 'chairisher/util/logging';
import { isTosAccepted, renderDefaultErrorOnTosField } from 'chairisher/view/helper/tosfield';

export default {
    loadAuthButton() {
        const $appleButton = $('.js-btn-apple');
        const $loginOrCreateForm = $appleButton.closest('form');

        AppleLoader.loadAuth().then((AppleAuth) => {
            AppleAuth.auth.init({
                clientId: getAppleClientId(),
                scope: 'name email',
                redirectURI: getAppleRedirectUri(),
                state: '',
                usePopup: true,
            });

            $appleButton.on('click', (e) => {
                e.preventDefault();

                if (isTosAccepted($loginOrCreateForm)) {
                    AppleAuth.auth
                        .signIn()
                        .then((data) => {
                            GoogleAnalyticsUtils.logEvent('Apple Sign In - Granted');
                            $loginOrCreateForm.find('[name=is_provider_initial_attempt]').val('1');
                            $loginOrCreateForm.find('[name=apple_auth_code]').val(data.authorization.code);
                            $loginOrCreateForm.find('[name=apple_id_token]').val(data.authorization.id_token);
                            $loginOrCreateForm.submit();
                        })
                        .catch(() => {
                            GoogleAnalyticsUtils.logEvent('Apple Sign In - Not Granted');
                        });
                } else {
                    renderDefaultErrorOnTosField($loginOrCreateForm);
                }
            });
        }, handleAsyncError);
    },
};
